// ---------------------------------------------------------------------------
// Das Anmelde-Ziel — wer auf einen Link klickt und sich erst anmelden muss,
// landet danach auf GENAU dieser Stelle (TAGESMAIL-1).
// ---------------------------------------------------------------------------
// Bis hierher fiel jeder Link nach der Anmeldung auf die Startseite: der
// Waechter merkte sich nur den Pfad (ohne `?…` und `#…`) im Router-Zustand,
// und den loescht die Microsoft-Anmeldung, weil sie die Seite ganz verlaesst.
// Die Morgenmail lebt aber von Links «direkt auf die Stelle» — ein Link, der
// nach dem Anmelden auf der Startseite endet, ist ein Link ins Leere.
//
// Darum steht das Ziel im `sessionStorage`: er gehoert dem Tab, ueberlebt den
// Umweg ueber Microsoft und Supabase und ist weg, sobald der Tab zu ist. Kein
// neuer Rueckweg-Parameter an der Anmeldung (die Supabase-Weiterleitungsliste
// bleibt unberuehrt, Memory `feedback_supabase_auth_config_patch`).
//
// Nur Pfade im OS selbst: beginnt das Ziel nicht mit genau einem «/», ist es
// kein Ziel (sonst waere das eine offene Weiterleitung auf fremde Seiten).

const SCHLUESSEL = "anmeldung.ziel";

/** Ein Ziel im OS — oder `null`, wenn es keins ist (fremd, leer, Anmeldung). */
export function sicheresAnmeldeZiel(ziel: string | null | undefined): string | null {
  if (typeof ziel !== "string" || ziel.length === 0) return null;
  if (!ziel.startsWith("/") || ziel.startsWith("//") || ziel.startsWith("/\\")) {
    return null;
  }
  if (ziel === "/" || ziel.startsWith("/login") || ziel.startsWith("/auth/")) {
    return null;
  }
  return ziel;
}

/** Merkt sich, wohin es nach der Anmeldung geht. */
export function merkeAnmeldeZiel(ziel: string): void {
  const sicher = sicheresAnmeldeZiel(ziel);
  if (sicher === null) return;
  try {
    window.sessionStorage.setItem(SCHLUESSEL, sicher);
  } catch {
    // Ohne Speicher (privates Fenster) landet der Klick auf der Startseite —
    // wie vor TAGESMAIL-1. Keine Anmeldung darf daran scheitern.
  }
}

// Einmal genommen, bleibt das Ziel fuer diesen Seitenaufruf stehen: React
// ruft Effekte im Entwicklungsmodus zweimal auf, und der zweite Aufruf darf
// nicht «kein Ziel → Startseite» ueber den ersten schreiben. Die Anmeldung
// selbst verlaesst die Seite immer ganz — danach beginnt der Speicher neu.
let genommen: string | null | undefined;

/** Holt das gemerkte Ziel (und raeumt es aus dem Speicher). */
export function nimmAnmeldeZiel(): string | null {
  if (genommen !== undefined) return genommen;
  try {
    const ziel = window.sessionStorage.getItem(SCHLUESSEL);
    window.sessionStorage.removeItem(SCHLUESSEL);
    genommen = sicheresAnmeldeZiel(ziel);
  } catch {
    genommen = null;
  }
  return genommen;
}

/** Nur fuer Tests: den Seitenaufruf neu beginnen. */
export function __vergissGenommenesAnmeldeZiel(): void {
  genommen = undefined;
}
